import { formatBytes } from '@billy/design-system'

export const getFileSizeLabel = (fileSize?: number) => (fileSize ? `(${formatBytes(fileSize)})` : '')
